import { Dictionary } from "../../../utils/sys/Dictionary";
import KeyedValueSorter from "./KeyedValueSorter";
import Ability from "../../../utils/game/mechanics/Ability";

export type SortKey = "title" | "level" | "subtype" | "school" | "cost" | "exhaustion" | "range" | "duration" | "accuracyCheck" | "description";

export default class AbilitySorter extends KeyedValueSorter {
    protected static override valueGetters = new Dictionary<SortKey, (ability: Ability) => string | number>([
        { key: "title", value: (ability) => ability.title },
        { key: "level", value: (ability) => ability.level },
        { key: "subtype", value: (ability) => ability.subtype },
        { key: "school", value: (ability) => ability.school },
        { key: "cost", value: (ability) => ability.cost },
        { key: "exhaustion", value: (ability) => ability.exhaustion },
        { key: "range", value: (ability) => ability.range },
        { key: "duration", value: (ability) => ability.duration },
        { key: "accuracyCheck", value: (ability) => ability.accuracyCheck === true ? 1 : 0 },
        { key: "description", value: (ability) => ability.description }
    ]);
}
